import baseConfig from "./baseconfig.json";
import Cookies from "universal-cookie";
import { decode as base64_decode } from "base-64";
import { map } from "lodash";

const host = window.location.protocol + "//" + window.location.host;

console.log(host);

const domainMapping = baseConfig.domainMapping;
// console.log('domainMapping**',domainMapping);

const currentFlavor =
  Object.keys(domainMapping).find((key) =>
    domainMapping[key].some((domain) => host.includes(domain))
  ) || "default";
 
 console.log(currentFlavor) 
const cookies = new Cookies();
const cookieData = cookies.get("data");
let industry = "";
let lat = "";
let long = "";
let latlng = [];

// console.log('cookieData**',cookieData);
//  console.log(JSON.parse(base64_decode(cookies.get("data"))).industry)
// console.log('currentFlavor**',currentFlavor);
// console.log('flavors**',baseConfig.flavors);

const selectedConfig = baseConfig.flavors[currentFlavor] || {};

if (cookieData) {
  industry = JSON.parse(base64_decode(cookieData)).industry;
  lat = JSON.parse(base64_decode(cookieData)).maplatitude;
  long = JSON.parse(base64_decode(cookieData)).maplongitude;
}

latlng = lat != null && long != null ? [lat, long] : selectedConfig.mapCenter;
// console.log(latlng, "latlng");
// console.log("selectedConfig**", selectedConfig, lat, long);
const conf = {
  ...baseConfig.common,
  ...selectedConfig,
  // mapCenter:
  //   industry === "Marine" ? [4.1857116, 73.5256716] : selectedConfig.mapCenter,
  // mapCenter: latlng,
  mapCenter: selectedConfig.mapCenter,
  fleetURL: selectedConfig.url + "/public/fleet",
  baseURL: selectedConfig.url + "/app/",
  fleetURLAdvertise: selectedConfig.url + "/public/fleet/",
  NodeCoreUrl: "https://pmispro.starlingtechs.com/",
  NodeUrl: selectedConfig.NodeCoreUrl,
  pythonReportlUrl: "http://13.126.174.243/pmistrackreact/api",
  validator: "jalboot",
};
console.log("first", conf.mapCenter);
export default conf;
